import React from 'react';
import { BRAND_LETTER } from '../../js/config/_global';
import { CLIENT_LETTERS } from '../../js/_constants';

import AudiGeneratedIcon from '@icons/audi-ai-generated.svg';
import AudiModifiedIcon from '@icons/audi-ai-modified.svg';
import VWGeneratedIcon from '@icons/volkswagen-ai-generated.svg';
import VWModifiedIcon from '@icons/volkswagen-ai-modified.svg';

const AiComplianceIcon = ({ aiCompliance }) => {
    if (!aiCompliance) {
        return null;
    }

    const { classification } = aiCompliance;


    const iconSrc = (() => {
        if (classification === "ai_generated" && BRAND_LETTER === CLIENT_LETTERS.volkswagen) {
            return VWGeneratedIcon;
        }

        if ((classification === "ai_modified" || classification === "ai_assisted") && BRAND_LETTER === CLIENT_LETTERS.volkswagen) {
            return VWModifiedIcon;
        }

        if (classification === "ai_generated") {
            return AudiGeneratedIcon;
        }

        if (classification === "ai_modified" || classification === "ai_assisted") {
            return AudiModifiedIcon;
        }

        return null;
    })();

    if (!iconSrc) {
        return null;
    }

    return <img src={iconSrc} className="ai-icon" data-testid={`ai-compliance-icon-${classification.split('_').pop()}`} />;
};

export default AiComplianceIcon;